import api from "../index";

export const AddUpdatePlanApi = (data, headers) => api.post('planmaster/add-update-plan', data, headers);
export const SyncGroupsApi = () => api.get('trading/groups-sync');
export const GetAllGroupListApi = () => api.get('trading/get-all-group');
export const GetAllPlansApi = (params) => api.get(`planmaster/get-all-plans?${params}`);
export const UpdatePlanStatusApi = (data) => api.post('planmaster/active-inactive-plan', data);
export const GetPlanByIdApi = (planId) => api.get(`planmaster/get-plan-byid/${planId}`);
export const GetGroupDetaisApi = (groupId) => api.get(`trading/get-group-info-byid/${groupId}`);

export const CreateGroupApi = (data) => api.post('trading/create-group', data);
export const GetGroupPlanNameApi = (params) => api.get(`planmaster/get-plan-group-name?${params}`);

